export default __webpack_public_path__ + "static/media/MERL.5f1cdfb5.svg";